<template>
  <div class="page">
    <div class="topTitle">
      <el-page-header @back="goBack">
        <template #content>
          <span class="text-large font-600 mr-3"> 学员考试 </span>
        </template>
      </el-page-header>
    </div>
    <div class="wrapper">
      <div class="header">
        <el-form class="form-style" :model="form1" size="mini" :inline="true">
          <el-form-item label="所属科目:" prop="subject_id">
            <el-select
              v-model="form1.subject_id"
              placeholder="请选择"
              @change="getSchoolExamList"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) of subjectList"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="考试名称:" prop="title">
            <el-input
              style="width: 200px"
              v-model="form1.exam_name"
              placeholder="请输入名称"
              clearable
              @keyup.enter.native="getSchoolExamList"
            ></el-input>
          </el-form-item>

          <el-checkbox
            v-model="form1.owned"
            style="float: right"
            @change="getSchoolExamList"
            >我的考试</el-checkbox
          >

          <el-form-item>
            <el-button
              class="search_btn"
              type="primary"
              size="mini"
              icon="el-icon-search"
              @click="search"
              >查询</el-button
            >

            <el-button
              class="search_btn"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="CreateExam"
              >新增考试
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="question_wrapper">
        <el-table
          size="mini"
          :data="examlist"
          :header-cell-style="{ background: '#f5f7fa', color: '#909399' }"
          stripe
        >
          <el-table-column align="center" width="50" label="序号">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 + (page_no - 1) * 20 }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" width="100" label="封面">
            <template slot-scope="scope">
              <el-image
                style="width: 40px; height: 18px"
                :src="scope.row.cover_url"
                fit="fill"
              ></el-image>
              <!-- <el-image v-else style="width: 40px; height: 18px" :src="image" fit="fill"></el-image> -->
            </template>
          </el-table-column>

          <el-table-column
            width="200"
            align="left"
            prop="title"
            label="考试名称"
            :show-overflow-tooltip="true"
          >
            <!-- <template slot-scope="scope">
              <el-link class="quest_btn" type="primary" @click="LookExam(scope.row)">{{ scope.row.title }}</el-link>
            </template> -->
          </el-table-column>

          <el-table-column
            width="100"
            align="center"
            label="总分"
            prop="paperInfo.total_score"
          >
          </el-table-column>
          <el-table-column
            width="100"
            align="center"
            label="题数"
            prop="paperInfo.total_num"
          >
          </el-table-column>
          <el-table-column width="100" align="center" label="考试时长(分钟)">
            <template slot-scope="scope">
              <span>{{ scope.row.lasttime / 60 }}</span>
            </template>
          </el-table-column>

          <el-table-column width="100" align="center" label="及格分数">
            <template slot-scope="scope">
              <span>{{ scope.row.passscore }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="提交情况">
            <template slot-scope="scope">
              <span
                >{{ scope.row.finished_num }} /
                {{ scope.row.stu_total_num }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            width="200"
            align="left"
            label="开始时间"
            prop="start_date"
          >
          </el-table-column>

          <el-table-column
            width="200"
            align="left"
            label="结束时间"
            prop="end_date"
          >
          </el-table-column>

          <el-table-column align="left" label="创建人" prop="realname">
          </el-table-column>

          <el-table-column align="center" label="开启状态">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                v-if="scope.row.post_state == '1'"
                type="success"
                effect="dark"
              ></el-tag>
              <el-tag size="mini" v-else type="info" effect="dark"></el-tag>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否开启">
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.post_state == '2'"
                @click="open(scope.row)"
              >
                开启</el-link
              >
              <el-link v-else @click="close(scope.row)">关闭</el-link>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" label="编辑" width="100">
            <template slot-scope="scope">
              <el-link class="quest_btn" type="primary" @click="EditExam(scope.row)">编辑</el-link>
  
              <el-link class="quest_btn" type="primary" @click="deleteExam(scope.row.id)">删除</el-link>
            </template>
          </el-table-column> -->

          <el-table-column
            align="center"
            label="操作"
            fixed="right"
            width="180"
          >
            <template slot-scope="scope">
              <!-- <el-link class="quest_btn" type="primary" @click="addExamStu(scope.row)">查看学员</el-link>
  
              <el-link class="quest_btn" type="primary" @click="ExamResult(scope.row)">成绩统计</el-link> -->

              <el-button @click="EditExam(scope.row)" type="text" size="mini"
                >编辑</el-button
              >
              <el-button @click="ExamResult(scope.row)" type="text" size="mini"
                >阅卷评分</el-button
              >
              <el-dropdown>
                <span class="el-dropdown-link">
                  更多
                  <i class="el-icon-arrow-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="addExamStu(scope.row)"
                    >查看学员</el-dropdown-item
                  >
                  <el-dropdown-item @click.native="LookExam(scope.row)"
                    >试卷预览</el-dropdown-item
                  >
                  <el-dropdown-item @click.native="deleteExam(scope.row.id)"
                    >删除</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="page_no"
          layout="total, prev, pager, next"
          :page-size="page_size"
          :total="total"
        ></el-pagination>
      </div>

      <el-dialog title="新增题库" :visible.sync="dialogVisible" width="40%">
        <el-form
          class="form-style"
          :model="form"
          size="mini"
          label-position="left"
        >
          <el-form-item label="序号" required prop="sort_num">
            <el-input-number
              v-model="form.sort_num"
              :precision="0"
            ></el-input-number>
          </el-form-item>

          <el-form-item label="所属科目" required prop="subject_id">
            <el-select v-model="form.subject_id" placeholder="请选择" clearable>
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) of subjectList"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="题库名称" required prop="title">
            <el-input v-model="form.title" placeholder="请输入名称"></el-input>
          </el-form-item>

          <el-form-item label="简介" required>
            <el-input
              type="textarea"
              v-model="form.desc"
              placeholder="请输入题库的简介"
            ></el-input>
          </el-form-item>

          <el-form-item label="封面" required prop="img_url">
            <el-upload
              action=""
              :http-request="uploadFile"
              :on-remove="handleRemove"
              :on-change="handleChangeFile"
              :auto-upload="false"
              :limit="1"
              :file-list="form.imgList"
              list-type="picture"
            >
              <el-button size="mini" type="primary" plain
                >点击上传<i class="el-icon-upload el-icon--right"></i
              ></el-button>
              <div slot="tip" class="el-upload__tip">
                <span style="color: red">推荐尺寸(750*340)</span>
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getSchoolExamList, deleteExam, changeState } from '@/api/educational'
import { getZoneSchoolSubjectList } from '@/api/community'

export default {
  name: 'CommonExam-ExamManagement',
  data() {
    return {
      image: 'https://wugecdn.steam.fun/resources/static/fighting.png',
      form1: {
        subject_id: '',
        exam_name: '',
        owned: true,
      },

      examlist: [],

      form: {
        sort_num: 1,
        title: '',
        subject_id: '',
        desc: '',
        img_url: '',
        imgList: [],
      },
      subjectList: [],
      dialogVisible: false, //新增题库
      input: '',
      page_no: 1,
      page_size: 20,
      total: 0,
      token: '',
      backPath: '',
    }
  },
  mounted() {
    this.getZoneSchoolSubjectList()
    this.getSchoolExamList()
    const backPath = window.sessionStorage.getItem('examBackPath')
    if (backPath) {
      this.backPath = backPath
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name) {
        if (from.name.indexOf('CommonExam-') === -1) {
          vm.backPath = from.path
          window.sessionStorage.setItem('examBackPath', from.path)
        }
      } else {
        next()
      }
    })
  },
  methods: {
    search() {
      this.page_no = 1
      this.getSchoolExamList()
    },

    open(row) {
      changeState({
        exam_id: row.id,
        post_state: 1,
      }).then((res) => {
        console.log(res)
        this.getSchoolExamList()
      })
    },
    close(row) {
      changeState({
        exam_id: row.id,
        post_state: 2,
      }).then((res) => {
        console.log(res)
        this.getSchoolExamList()
      })
    },
    getZoneSchoolSubjectList() {
      console.log('查询校区科目')

      getZoneSchoolSubjectList().then((res) => {
        console.log('校区科目')
        console.log(res)
        this.subjectList = res.subjectList
      })
    },

    getSchoolExamList() {
      getSchoolExamList({
        title: this.form1.exam_name,
        subject_id: this.form1.subject_id,
        isShowSelfPaper: this.form1.owned, //是否只显示本人创建的试卷 true false
        search_user_id: '', //个人id
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('考试列表')
        console.log(res)
        this.examlist = res.examList
        this.total = res.total
      })
    },

    deleteExam(id) {
      this.$confirm('删除后,学生的作答记录也一并会删除!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteExam({
          examId: id,
        }).then((res) => {
          console.log('删除考试')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.getSchoolExamList()
          }
        })
      })
    },

    //添加试题
    AddQuestion(row) {
      console.log('添加试题')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-AddQuestion',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    QuestionManagement(row) {
      console.log('试题管理')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-Questionlist',
        query: {
          id: row.id,
          title: row.title,
        },
      })
    },
    Practice(row) {
      console.log('练习')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-Practice',
        query: {
          id: row.id,
          title: row.title,
          passscore: row.passscore,
        },
      })
    },

    EditExam(row) {
      console.log('编辑考试')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-EditExam',
        query: {
          title: row.title,
          id: row.id,
        },
        params: {
          examinfo: row,
        },
      })
    },

    LookExam(row) {
      console.log('查看考试')
      console.log(row)
      this.$router.push({
        name: 'CommonExam-PaperDetail',
        query: {
          id: row.paperInfo.id,
          title: row.title,
        },
      })
    },

    addExamStu(row) {
      console.log('考生编辑')
      this.$router.push({
        name: 'CommonExam-EditExamstu',
        query: {
          title: row.title,
          id: row.id,
          subject_id: row.subject_id,
        },
        params: {
          examClassArr: row.examClassArr,
          examCampusArr: row.examCampusArr,
        },
      })
    },

    CreateExam() {
      console.log('创建考试')
      this.$router.push({
        name: 'CommonExam-CreateExam',
      })
    },

    ExamResult(row) {
      console.log('成绩统计')
      this.$router.push({
        name: 'CommonExam-ExamResult',
        query: {
          id: row.id,
          title: row.title,
          passscore: row.passscore,
        },
      })
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.getSchoolExamList()
    },
    handleChangeFile() {},
    handleRemove() {},
    uploadFile() {},
    goBack() {
      if (this.backPath) {
        this.$router.replace(this.backPath)
      } else {
        throw Error('无路由来源')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  padding: 20px 50px;
  max-width: 1680px;
  margin: auto;
  .topTitle {
    height: 60px;
    background: #fff;
    margin: 10px;
    padding: 20px;
    border-radius: 5px;
    box-sizing: border-box;
    font-size: 14px;
  }
  .wrapper {
    box-sizing: border-box;
    min-height: 100%;
    margin: 10px;
    padding-top: 5px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;

    background: white;
    border-radius: 5px;

    .header {
      .search {
        width: 250px;
      }

      .search_btn {
        margin-left: 20px;
      }
    }

    .question_wrapper {
      margin-top: 0px;

      .quest_btn {
        margin-left: 5px;
        margin-right: 5px;
      }
    }

    .el-dropdown-link {
      cursor: pointer;
      color: #409eff;
      font-size: 12px;
      padding-right: 5px;
      padding-left: 10px;
    }
  }
}
</style>
